<div class="component-container">
  <div class="component-header">
    <h2>Create New Large Shareholder</h2>
  </div>
  <app-large-shareholder-form
    [form]="form"
    [isEditMode]="false"
    submitButtonText="Create Large Shareholder"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-large-shareholder-form>
</div>
